import axios from "axios";
import store from '../q-store';
import qElement from '../q-element';
import local from '../q-local'

const notify = qElement.Notification;

function showExceptions(exceptions) {
  if(!exceptions)
    return;
  exceptions.forEach((item) => {
    notify.error({
      title: item.title,
      message: item.message
    });
  });
}

export const delegate = (plugin, delegate, data) => {
  const url = "/api/call";

  store.state.loader = true;
  let session = null;
  if (store.state.session)
    session = store.state.session;

  return new Promise((resolve, reject) => {
    axios.post(url, {
      plugin: plugin,
      delegate: delegate,
      session: session,
      data: data
    }).then((response) => {

      store.state.loader = false;
      if (response.data.status === 200) {
        resolve({
          result: response.data.result,
          message: response.data.message
        });
      } else {
        showExceptions(response.data.exceptions);
        reject();
      }
    }).catch((error) => {
      store.state.loader = false;
      notify.error({
        title: local.qt('notify.exceptionTitle'),
        message: error
      });
      reject();
    });
  });
};

export const service = (plugin, model, method, data) => {
  const url = "/api/call";

  store.state.loader = true;
  let session = null;
  if (store.state.session)
    session = store.state.session;

  return new Promise((resolve, reject) => {
    axios.post(url, {
      plugin: plugin,
      model: model,
      method: method,
      session: session,
      data: data
    }).then((response) => {


      store.state.loader = false;
      if (response.data.status === 200) {
        resolve({
          result: response.data.result,
          message: response.data.message
        });
      } else {
        showExceptions(response.data.exceptions);
        reject();
      }
    }).catch((error) => {
      store.state.loader = false;
      notify.error({
        title: local.qt('notify.exceptionTitle'),
        message: error
      });
      reject();
    });
  });
};


export default {delegate, service};


